import '@fancyapps/fancybox';
import Handlebars from 'handlebars';
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
// If change, then change code/config/app.php.
var GTM_CONTAINER_ID = 'G-5EEYH7MZPX';
function requiredQuerySelector(selector) {
    var elm = document.querySelector(selector);
    if (!elm) {
        throw new Error("Failed to locate required element: \"".concat(selector, "\"."));
    }
    return elm;
}
function convertProductToGtagItem(product) {
    var _a;
    return {
        item_id: product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: (_a = product.quantity) !== null && _a !== void 0 ? _a : 1,
    };
}
function convertProductsToGtagItems(products) {
    var items = [];
    for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
        var product = products_1[_i];
        items.push(convertProductToGtagItem(product));
    }
    return items;
}
function getProductsTotal(products) {
    var total = 0;
    for (var _i = 0, products_2 = products; _i < products_2.length; _i++) {
        var product = products_2[_i];
        total += product.price;
    }
    return total;
}
/**
 * base.html
 * Initializes Sentry error tracking.
 *
 * Should be one of the first script to run.
 *
 * @param dsn Sentry DSN URL.
 * @param environment Deployement environement (e.g. "production").
 * @param release Release version (e.g. "1.0.0").
 * @param debug Whether this is the debug version or the production version.
 */
export function initSentry(dsn, environment, release, debug) {
    Sentry.init({
        dsn: dsn,
        environment: environment,
        release: release,
        debug: debug,
        integrations: [new Integrations.BrowserTracing({
                tracingOrigins: ['localhost', /^[a-z]+\.libertys\.com/, /^\//],
            })],
        // Sentry 9.1 does not support this.
        autoSessionTracking: false,
    });
}
/**
 * Measuring Product Impressions - Enhanced Ecommerce.
 * See https://developers.google.com/tag-manager/enhanced-ecommerce
 *
 * Only measure an impression when the element is actually shown for a short time.
 */
function logProductImpressions(elements, list, currencyCode) {
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_item_list
    var items = [];
    elements.forEach(function (element) {
        var ref = element.dataset.ref;
        var name = element.title;
        var price = element.dataset.price ? parseFloat(element.dataset.price) : undefined;
        var position = element.dataset.position ? parseInt(element.dataset.position, 10) : undefined;
        items.push({
            item_id: ref,
            item_name: name,
            price: price,
            index: position,
        });
    });
    gtag('event', 'view_item_list', {
        item_list_name: list,
        items: items,
    });
}
/**
 * search_results.html
 * @param currencyCode Currency code.
 */
export function runSearchResults(currencyCode) {
    setupItemListingLogging('Search Results', currencyCode);
}
/**
 * category.html
 * @param categoryName Current category name.
 * @param currencyCode Currency code.
 */
export function runCategory(categoryName, currencyCode) {
    setupItemListingLogging('Category', currencyCode, categoryName);
}
/**
 * item.html
 * @param product Product displayed.
 * @param currencyCode Currency code.
 * @param itemInfoUrl URL to refresh the info.
 */
export function runItem(product, currencyCode, itemInfoUrl) {
    // Measuring Views of Product Details - Enhanced Ecommerce
    // See https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_item_details
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_item
    gtag('event', 'view_item', {
        currency: currencyCode,
        value: product.price,
        items: [convertProductToGtagItem(product)],
    });
    // Add to cart event.
    $('a.addItem').on('click', function (evt) {
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_to_cart
        gtag('event', 'add_to_cart', {
            currency: currencyCode,
            value: product.price,
            items: [convertProductToGtagItem(product)],
        });
    });
    // Measuring Checkout.
    $('a.buynow').on('click', function (evt) {
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_payment_info
        gtag('event', 'add_payment_info', {
            currency: currencyCode,
            value: product.price,
            payment_type: 'PayPal',
            items: [convertProductToGtagItem(product)],
        });
    });
    setUpDynamicShippingCost(itemInfoUrl);
    setupItemListingLogging('Item', currencyCode);
}
function setupItemListingLogging(list, currencyCode, category) {
    // Log impressions.
    logProductImpressions(document.querySelectorAll('a.item'), list, currencyCode);
    // View item's details.
    $('a.item').on('click', function (evt) {
        var elem = evt.currentTarget;
        var ref = $(elem).data('ref');
        var name = elem.title;
        var price = $(elem).data('price');
        var position = $(elem).data('position');
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_item
        gtag('event', 'view_item', {
            currency: currencyCode,
            value: price,
            items: [{
                    item_id: ref,
                    item_name: name,
                    item_category: category,
                    price: price,
                    item_list_name: list,
                    index: position,
                }],
        });
    });
}
function setUpDynamicShippingCost(itemInfoUrl) {
    var shippingCostElem = document.getElementById('shipping-cost');
    var shippingAreaElem = document.querySelector('select[name=shipping_area]');
    if (!shippingCostElem || !shippingAreaElem) {
        if (document.querySelector('.out-of-stock')) {
            // Perfectly normal not to have shipping for out of stock items.
            return;
        }
        Sentry.captureException(new Error('Shipping element not found in the DOM.'));
        return;
    }
    var refreshShippingInfo = function (json) {
        if (!json) {
            Sentry.captureException(new Error('Null shipping info returned.'));
            return;
        }
        shippingCostElem.innerHTML = json.shippingCost;
        $('select[name=shipping_area] option[value="' + json.shippingArea + '"]').prop('selected', true);
        var shippingDurationFrance = document.getElementById('shipping-duration-france');
        var shippingDuration24hours = document.getElementById('shipping-duration-24-hours');
        if (shippingDurationFrance && shippingDuration24hours) {
            shippingDurationFrance.style.display = json.shippingArea == 'france' ? '' : 'none';
            shippingDuration24hours.style.display = json.shippingArea != 'france' ? '' : 'none';
        }
        shippingAreaElem.disabled = false;
    };
    $('select[name=shipping_area]').change(function (evt) {
        var newShippingArea = $(evt.currentTarget).val();
        $.ajax({
            url: itemInfoUrl,
            data: { 'shipping_area': newShippingArea },
            success: refreshShippingInfo,
        });
    });
    // Sets country code using GeoIP
    // Ideally do this server-side using https://nginx.org/en/docs/http/ngx_http_geoip_module.html
    $.get('https://ipinfo.io/json', function (response) {
        $.ajax({
            url: itemInfoUrl,
            data: { 'country': response.country },
            success: refreshShippingInfo,
        });
    });
}
/**
 * cart.html
 * @param recaptchaSiteKey reCaptcha key.
 * @param products Products in the cart.
 * @param cartUrl URL of the cart Ajax.
 * @param currencyCode Currency code (e.g. "EUR").
 */
export function runCart(recaptchaSiteKey, products, cartUrl, currencyCode) {
    grecaptcha.ready(function () {
        grecaptcha.execute(recaptchaSiteKey, { action: 'cart' });
    });
    $('#shipping-amount .free-shipping-notice').hide();
    var compiledTemplate = Handlebars.compile(requiredQuerySelector('#item-template').innerHTML);
    var refreshCard = function (result) {
        for (var _i = 0, _a = result.cart_items; _i < _a.length; _i++) {
            var cartItem = _a[_i];
            // Hide the shipping fee not waivable (star) marker when the target country may not have
            // any item with waivable shipping fees (and we wouldn't show the notice).
            cartItem.shipping_fee_not_waivable =
                result.shipping_area === 'france' && !cartItem.is_shipping_fee_waivable;
        }
        var rendered = compiledTemplate({ 'cart_items': result.cart_items });
        requiredQuerySelector('.books-list').innerHTML = rendered;
        requiredQuerySelector('#items-amount .cart-sub-total').innerHTML = result.items_amount;
        $('#shipping-amount select').val(result.shipping_area);
        if (result.shipping_area == 'france' && !result.is_shipping_offered) {
            $('#shipping-amount .free-shipping-notice').show(200);
        }
        else {
            $('#shipping-amount .free-shipping-notice').hide(200);
        }
        requiredQuerySelector('#shipping-amount .cart-sub-total').innerHTML =
            result.shipping_amount;
        requiredQuerySelector('#total-amount .cart-sub-total').innerHTML =
            result.total_amount;
    };
    $.ajax({
        url: cartUrl,
        success: refreshCard,
    });
    $('form.cart').on('click', '.books-list .remove button', function (evt) {
        var itemRef = $(evt.currentTarget).val();
        $.ajax({
            url: cartUrl,
            data: { 'remove_item': itemRef },
            success: refreshCard,
        });
        // Removing a Product from a Shopping Cart - Enhanced Ecommerce
        // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#add_or_remove_an_item_from_a_shopping_cart
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#remove_from_cart
        var product;
        for (var _i = 0, products_3 = products; _i < products_3.length; _i++) {
            var productInCart = products_3[_i];
            if (productInCart.id == itemRef) {
                product = productInCart;
                break;
            }
        }
        if (product) {
            gtag('event', 'remove_from_cart', {
                currency: currencyCode,
                value: product.price,
                items: [convertProductToGtagItem(product)],
            });
        }
        evt.preventDefault();
    });
    $('#shipping-amount select').change(function (evt) {
        $.ajax({
            url: cartUrl,
            data: { 'shipping_area': $(evt.currentTarget).val() },
            success: refreshCard,
        });
    });
    // Style fixes (hack).
    $('#scroll_to_page_top').hide();
    // Measuring a Checkout - Enhanced Ecommerce
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_cart
    gtag('event', 'view_cart', {
        currency: currencyCode,
        value: getProductsTotal(products),
        items: [convertProductsToGtagItems(products)],
    });
    // Measuring Product Clicks.
    $('a.item').on('click', function (evt) {
        var elem = evt.currentTarget;
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_item
        var ref = $(elem).data('ref');
        var name = elem.title;
        var price = $(elem).data('price');
        gtag('event', 'view_item', {
            currency: currencyCode,
            value: price,
            items: [{
                    item_id: ref,
                    item_name: name,
                    price: price,
                }],
        });
    });
    $('input[name=paypal]').on('click', function (evt) {
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_payment_info
        gtag('event', 'add_payment_info', {
            currency: currencyCode,
            value: getProductsTotal(products),
            payment_type: 'PayPal Express',
            items: convertProductsToGtagItems(products),
        });
    });
    // Measuring a Checkout - Enhanced Ecommerce
    $('input[name=checkout]').on('click', function (evt) {
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#begin_checkout
        gtag('event', 'begin_checkout', {
            currency: currencyCode,
            value: getProductsTotal(products),
            items: convertProductsToGtagItems(products),
        });
    });
}
/**
 * payment-paypal-review.html
 * @param products Products in the cart.
 * @param currencyCode Currency code (e.g. "EUR").
 * @param paymentType The chosen method of payment (e.g. "Credit Card").
 */
export function logEcommercePaymentInfo(products, currencyCode, paymentType) {
    // Measuring Purchases - Enhanced Ecommerce
    // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#initiate_the_checkout_process
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_payment_info
    gtag('event', 'add_payment_info', {
        currency: currencyCode,
        value: getProductsTotal(products),
        payment_type: paymentType,
        items: convertProductsToGtagItems(products),
    });
}
/**
 * payment-paypal-success.html
 * payment-lyra-success.html
 * @param transactionId Translation ID for purchases and refunds.
 * @param total Total transaction value (including tax and shipping).
 * @param shipping Shipping cost.
 * @param products Products in the cart.
 * @param currencyCode Currency code (e.g. "EUR").
 */
export function logEcommercePurchase(transactionId, total, shipping, products, currencyCode) {
    // Measuring Purchases - Enhanced Ecommerce
    // https://developers.google.com/tag-manager/enhanced-ecommerce
    // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#initiate_the_checkout_process
    gtag('event', 'purchase', {
        transaction_id: transactionId,
        currency: currencyCode,
        value: total,
        shipping: shipping,
        items: convertProductsToGtagItems(products),
    });
}
/**
 * email-form.html
 * @param recaptchaSiteKey reCaptcha key.
 */
export function runEmailForm(recaptchaSiteKey) {
    grecaptcha.ready(function () {
        grecaptcha.execute(recaptchaSiteKey, { action: 'email' }).then(function (token) {
            if (token) {
                document.getElementById('email-captcha').value = token;
                document.getElementById('email-submit').disabled = false;
            }
        });
    });
}
/**
 * error404.html
 * @param recaptchaSiteKey reCaptcha key.
 * @param isSystemTest Whether this is a system test.
 * @param reportUrl URL to ping.
 */
export function reportError404(recaptchaSiteKey, isSystemTest, reportUrl) {
    grecaptcha.ready(function () {
        var reportError = function (token) {
            var url = new URL(reportUrl);
            url.searchParams.append('token', token);
            fetch(url.toString()).then(function () {
                console.info('Logged 404.');
            });
        };
        if (isSystemTest) {
            reportError('system-test');
        }
        else {
            grecaptcha.execute(recaptchaSiteKey, {
                action: '404',
            }).then(function (token) {
                reportError(token);
            });
        }
    });
}
